var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullseyeDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.5C6.75 6.92188 6.39844 7.25 6 7.25C5.57812 7.25 5.25 6.92188 5.25 6.5C5.25 6.10156 5.57812 5.75 6 5.75C6.39844 5.75 6.75 6.10156 6.75 6.5ZM2.625 6.5C2.625 4.64844 4.125 3.125 6 3.125C7.85156 3.125 9.375 4.64844 9.375 6.5C9.375 8.375 7.85156 9.875 6 9.875C4.125 9.875 2.625 8.375 2.625 6.5ZM6 8.375C7.03125 8.375 7.875 7.55469 7.875 6.5C7.875 5.46875 7.03125 4.625 6 4.625C4.94531 4.625 4.125 5.46875 4.125 6.5C4.125 7.55469 4.94531 8.375 6 8.375ZM12 6.5C12 9.82812 9.30469 12.5 6 12.5C2.67188 12.5 0 9.82812 0 6.5C0 3.19531 2.67188 0.5 6 0.5C9.30469 0.5 12 3.19531 12 6.5ZM6 2C3.49219 2 1.5 4.01562 1.5 6.5C1.5 8.98438 3.49219 11 6 11C8.48438 11 10.5 8.98438 10.5 6.5C10.5 4.01562 8.48438 2 6 2Z",
    fill: "#56627C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseyeDark);
export default __webpack_public_path__ + "static/media/bullseye-dark.6a2e2d0f967f72bd659de67205ac7c29.svg";
export { ForwardRef as ReactComponent };